import React from 'react'
import { Button, Popover } from '@mui/material'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded'
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded'

import useCurrentUser from '../../../hooks/useCurrentUser'
import useStyles from './_styles'
import HeaderUserMenuContent from './HeaderUserMenuContent'

const HeaderUserMenu = () => {
    const classes = useStyles()
    const currentUser = useCurrentUser()

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)
    const id = open ? 'HeaderHcsSwitch-popover' : undefined

    return (
        <>
            <Button className={classes.HeaderUserMenuButton} onClick={handleClick} data-cy="dataCy_openUseRMenu">
                <div className={classes.HeaderUserMenuIcon}>
                    <AccountCircleRoundedIcon />
                </div>
                <div className={classes.HeaderUserMenuFullname}>
                    <span className={classes.HeaderUserMenuButtonName}>{currentUser.fullName}</span>
                </div>
                <ArrowDropDownRoundedIcon />
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <HeaderUserMenuContent handleClose={handleClose} />
            </Popover>
        </>
    )
}

export default HeaderUserMenu
